import React from "react";
import { Fade } from "react-reveal";
import styled from "styled-components";

const Heading = ({
  heading,
  subheading,
  headingFontSize,
  subheadingFontSize,
}) => {
  return (
    <Fade left duration={1000}>
      <HeadingBox>
        <h2 style={{ fontSize: headingFontSize ?? "3rem" }}>{heading}</h2>
        <p style={{ fontSize: subheadingFontSize ?? "1rem" }}>{subheading}</p>
      </HeadingBox>
    </Fade>
  );
};

export default Heading;

export const HeadingBox = styled.div`
  display: flex;
  margin: auto;
  flex-direction: column;
  max-width: 1128px;
  padding: 40px 0px;
  display: flex;

  @media (max-width: 1100px) {
    margin: 10px 30px;
  }
  @media (max-width: 768px) {
    margin: 10px 10px;
  }

  & > h2 {
    color: var(--secondary);
    font-size: 3rem;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 2.2rem;
    }
  }
  & > p {
    padding-top: 10px;

    color: var(--secondary);
    font-size: 1rem;

    @media (max-width: 768px) {
      font-size: 0.8rem;
      padding-top: 10px;
    }
  }
`;
